import { accountIdFormat } from "@redotech/redo-account-id";
import {
  consolidationGroupIdFormat,
  consolidationScheduleIdFormat,
  returnsCenterIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";
import { ConsolidationScheduleRecurrenceSchema } from "./consolidation-schedule-fields";

export const ConsolidationReturnsCenterSchema = z.object({
  country: z.string().nullable(),
  id: returnsCenterIdFormat.schema,
  name: z.string(),
});

export const ConsolidationScheduleSchema = z.object({
  enabled: z.boolean(),
  id: consolidationScheduleIdFormat.schema,
  isDefault: z.boolean(),
  name: z.string(),
  nextOccurrenceAt: z.date(),
  recurrence: ConsolidationScheduleRecurrenceSchema,
  returnsCenterId: returnsCenterIdFormat.schema,
  startsAt: z.date(),
  timezone: z.string(),
});

export const ConsolidationGroupSchema = z.object({
  consolidationScheduleId: consolidationScheduleIdFormat.schema,
  consolidationScheduleName: z.string(),
  destinationCenterId: returnsCenterIdFormat.schema,
  destinationCenterName: z.string(),
  enabled: z.boolean(),
  id: consolidationGroupIdFormat.schema,
  name: z.string(),
  returnsCenterId: returnsCenterIdFormat.schema,
});

export const ConsolidationAssignmentSchema = z.object({
  consolidationGroupId: consolidationGroupIdFormat.schema.nullable(),
  consolidationScheduleId: consolidationScheduleIdFormat.schema.nullable(),
  merchantAccountId: accountIdFormat.schema,
  returnsCenterId: returnsCenterIdFormat.schema,
});

export const getConsolidationSettings = {
  name: "getConsolidationSettings" as const,
  input: z.object({}),
  output: z.object({
    assignments: z.array(ConsolidationAssignmentSchema),
    destinationCenters: z.array(ConsolidationReturnsCenterSchema),
    groups: z.array(ConsolidationGroupSchema),
    originCenters: z.array(ConsolidationReturnsCenterSchema),
    schedules: z.array(ConsolidationScheduleSchema),
  }),
};
